// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"056345c0","341":"c763f8a0","387":"805134be","576":"dff11287","724":"1916863c"}[chunkId] + ".chunk.js";
};